module.exports = __webpack_public_path__ + "static/organic-search-row-nine-hero-b874a418b792028ca5cc97b0c4f725be.png";